import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
import { CustomAccount } from 'gc-backend';

export type State = {
  associatedGiftAccounts: { [key: string]: CustomAccount } | {};
};

export const reducer = combineReducers<State, RootAction>({
  associatedGiftAccounts: (state = {}, action) => {
    switch (action.type) {
      case OMS_LOOKUP_SUCCESS:
        return action.payload.associatedGiftAccounts;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/gifts/reducer.ts